import { Component, Input, OnInit } from '@angular/core';
import { RequestModel } from 'src/app/models/request.model';
import Swal from 'sweetalert2';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['../request-search.component.css', '../../../pages.component.css']
})
export class SearchResultComponent implements OnInit {

  @Input() requests: RequestModel[] = [];
  config = {
    id: 'custom',
    itemsPerPage: 5,
    currentPage: 1,
    totalItems: this.requests.length
  };

  constructor(public _auth: AuthService) { }

  ngOnInit(): void {
  }

  download() {
    Swal.fire({
      html: "<h3 class='alert-question'>Se ha descargado correctamente la planilla Excel</h3>",
      showClass: {
        popup: 'animated fadeIn fast'
      },
      hideClass: {
        popup: 'animated fadeOut fast'
      },
      icon: 'success',
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        content: "content-class",
        closeButton: 'close-button-class',
      }
    })
  }

  canDownload() {
    const expectedRoles = [1201, 1205]
    const result = this._auth.user
      .getUserData()
      .roles.filter((role) => expectedRoles.indexOf(role.id) > -1);
    return result.length > 0;
  }
}
